import { connect } from 'react-redux';
import { noop, some } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';
import renderField from '../../../../components/Field/reduxForm';
import Button from 'components/Button';
import Loading from 'components/Loading';
import { getRequiredFn } from '../../../../utils/reduxForm/validations';

const required = getRequiredFn();
const passwordMinLength = 7;
const formName = 'setPassword';
const select = formValueSelector(formName);

@connect((state) => ({
  password: select(state, 'newPassword1'),
  confirmPassword: select(state, 'newPassword2'),
}))
class SetPasswordForm extends React.Component {
  static propTypes = {
    innerError: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
  };

  state = {
    showNewPassword1: false,
    showNewPassword2: false,
  };

  getValidationFlags = (value) => {
    const password = value || this.props.password || '';

    return {
      invalidLength: password.length < passwordMinLength,
      noCaps: password.search(/[A-Z]/) === -1,
      noLowers: password.search(/[a-z]/) === -1,
      noDigital: password.search(/[0-9]/) === -1,
      noSymbols: password.search(/[#$^&*_\-+%@]/) === -1,
    };
  };

  getShowOrHidePasswordLink(passwordType) {
    return (
      <a onClick={() => this.setState({ [passwordType]: !this.state[passwordType] })}>
        {this.state[passwordType] ? 'Скрыть пароль' : 'Показать пароль'}
      </a>
    );
  }

  validatePasswordField = (value) => {
    const validationFlags = this.getValidationFlags(value);
    if (some(validationFlags, (value) => value)) {
      return 'Пароль не соответствует обязательным условиям';
    }
    return null;
  };

  validatePassword2Field = (value, values, props, fieldName) => {
    if (fieldName === 'newPassword1') {
      return;
    }
    const { newPassword1, newPassword2 } = values.toJS();
    return newPassword1 !== newPassword2 ? 'Пароли не совпадают' : null;
  };

  render() {
    const { handleSubmit, loading, password, confirmPassword } = this.props;
    const { showNewPassword1, showNewPassword2 } = this.state;
    const validationFlags = this.getValidationFlags();
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <h2>Задайте постоянный пароль</h2>
          <div className="profile_password js-add-block">
            <p>
              Для первого входа вы воспользовались временным паролем. Придумайте постоянный пароль
              для своего кабинета.
            </p>
            <div className="link link_attention-red">
              Новый пароль обязательно должен содержать:
            </div>
            <ul className="list list__dark profile_list">
              <li className={classnames({ red: validationFlags.invalidLength })}>
                Не менее 7 символов
              </li>
              <li className={classnames({ red: validationFlags.noCaps })}>
                Прописные латинские буквы (A-Z)
              </li>
              <li className={classnames({ red: validationFlags.noLowers })}>
                Строчные латинские буквы (a-z)
              </li>
              <li className={classnames({ red: validationFlags.noDigital })}>
                Арабские цифры (0-9)
              </li>
              <li className={classnames({ red: validationFlags.noSymbols })}>
                Спецсимволы (#,$,^,&,*,_,-,+,%,@)
              </li>
            </ul>

            <div className="cRow">
              <div className="form_item">
                <Field
                  name="newPassword1"
                  component={renderField}
                  type={showNewPassword1 ? 'text' : 'password'}
                  label="Введите пароль"
                  validate={[required, this.validatePasswordField, this.validatePassword2Field]}
                />
                {password && password.length
                  ? this.getShowOrHidePasswordLink('showNewPassword1')
                  : null}
              </div>
            </div>
            <div className="cRow">
              <div className="form_item">
                <Field
                  name="newPassword2"
                  component={renderField}
                  type={showNewPassword2 ? 'text' : 'password'}
                  label="Введите пароль еще раз"
                  validate={[required, this.validatePassword2Field]}
                />
                {confirmPassword && confirmPassword.length
                  ? this.getShowOrHidePasswordLink('showNewPassword2')
                  : null}
              </div>
            </div>
          </div>
          {this.props.innerError ? (
            <div className="cRow" style={{ marginBottom: '30px' }}>
              <div className="red">{this.props.innerError}</div>
            </div>
          ) : null}
          <div className="cRow cRow__tablet">
            <div className="cCol">
              <Button
                isDisabled={loading}
                buttonStyle={{ position: 'relative', minWidth: '210px' }}
                onClick={noop}
                type="submit"
                size="medium"
                color="orange"
              >
                {loading ? <Loading isLight={true} /> : 'Подтвердить'}
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: formName,
})(SetPasswordForm);
